module.exports = __webpack_public_path__ + "img/LCATree3_Front.bc9555e7.png";